module.exports = __webpack_public_path__ + "img/icon-card-line.e9bb15d4.svg";